import {
  Box,
  Button,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
  Heading,
  useTheme,
} from '@razorpay/blade/components';
import React from 'react';
import EmployRequestEnableLight from '../../../assets/loan/employee-request-enabled-light.png';
import EmployRequestEnable from '../../../assets/loan/employee-request-enabled.png';
interface EnableRequestsSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateCategory: () => void;
}

export const EnableRequestsSuccessModal = ({
  isOpen,
  onClose,
  onCreateCategory,
}: EnableRequestsSuccessModalProps) => {
  const { colorScheme } = useTheme();
  const isDark = colorScheme === 'dark';

  return (
    <Modal isOpen={isOpen} onDismiss={onClose} size="small">
      <ModalHeader />
      <ModalBody padding="spacing.0">
        <Box display="flex" flexDirection="column" alignItems="center">
          <Box
            flexShrink={0}
            display="flex"
            alignItems="center"
            justifyContent="center"
            width="100%"
            height="214px">
            <img
              src={isDark ? EmployRequestEnable : EmployRequestEnableLight}
              alt="Enable Success"
              onError={(e) => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          </Box>
          <Box display="flex" flexDirection="column" gap="spacing.7" padding="spacing.6">
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Heading size="small" weight="semibold" color="surface.text.gray.normal">
                Employee Requests Enabled!
              </Heading>
              <Text size="small" variant="body" weight="regular" color="surface.text.gray.subtle">
                Employees can now request loans through their self-service portal. You're all set to
                start receiving and managing requests.
              </Text>
            </Box>
            <Box display="flex" flexDirection="column" gap="spacing.3">
              <Text size="small" variant="body" weight="semibold" color="surface.text.gray.normal">
                What's next?
              </Text>
              <List size="small" marginTop="spacing.3">
                <ListItem>Add categories like Medical, Personal, or Housing</ListItem>
                <ListItem>Define terms and conditions in your policy</ListItem>
                <ListItem>Employees will see clear categories when applying</ListItem>
              </List>
            </Box>
          </Box>
        </Box>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.4" width="100%">
          <Button variant="tertiary" isFullWidth onClick={onClose}>
            Do This Later
          </Button>
          <Button isFullWidth onClick={onCreateCategory}>
            Create Category
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
